import {
  Component,
  ChangeDetectionStrategy,
  forwardRef,
  Input,
  ContentChild,
  TemplateRef,
  ChangeDetectorRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DropdownComponent),
    multi: true
  }]
})
export class DropdownComponent implements ControlValueAccessor {
  @Input() items: any[] = [];
  @Input() bindValue?: string;
  @Input() placeholder: string = 'Select...';
  @Input() multiple = false;
  @Input() searchable = true;
  @Input() clearable = true;
  @Input() bindLabel: string = 'name';

  value: any;
  disabled = false;

  @ContentChild('optionTpl', { read: TemplateRef }) optionTpl?: TemplateRef<any>;
  @ContentChild('selectedItemTpl', { static: false }) selectedItemTpl?: TemplateRef<any>;

  private onChange: (v: any) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(val: any): void {
    this.value = val;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void { this.onChange = fn; }

  registerOnTouched(fn: any): void { this.onTouched = fn; }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  setValue(v: any): void {
    this.value = v;
    this.onChange(v);
    this.onTouched();
    this.cdr.markForCheck();
  }
}
